var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 296,
    viewBox: "0 0 334 296",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.05 296C18.37 296 12.525 293.499 7.515 288.496C2.505 283.493 0 277.656 0 270.986V54.1972C0 47.5268 2.505 41.6901 7.515 36.6873C12.525 31.6845 18.37 29.1831 25.05 29.1831H206.245C205.41 33.3521 204.853 37.5211 204.575 41.6901C204.297 45.8592 204.436 50.0282 204.992 54.1972H27.1375L167 145.082L230.042 104.225C232.826 106.727 235.748 109.044 238.81 111.176C241.872 113.309 245.072 115.161 248.412 116.732L167 170.096L25.05 77.1268V270.986H308.95V120.901C313.624 119.572 317.994 117.711 322.058 115.319C326.123 112.926 330.103 110.201 334 107.144V270.986C334 277.656 331.495 283.493 326.485 288.496C321.475 293.499 315.63 296 308.95 296H25.05ZM283.851 91.7183C271.08 91.7183 260.242 87.255 251.335 78.3283C242.428 69.4018 237.975 58.5624 237.975 45.81C237.975 33.0578 242.445 22.2347 251.384 13.3408C260.323 4.44695 271.178 0 283.949 0C296.72 0 307.558 4.46334 316.465 13.39C325.372 22.3165 329.825 33.1559 329.825 45.9084C329.825 58.6605 325.355 69.4836 316.416 78.3775C307.477 87.2714 296.621 91.7183 283.851 91.7183Z",
    fill: "#F0F1F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.ac100c4ed52a85d41836680b23f12635.svg";
export { ForwardRef as ReactComponent };